const parcoursData = [
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Booster sa carrière',
  "Catégorie 2 - Pitch": 'Faire évoluer sa posture professionnelle, renforcer ses capacités et devenir acteur de sa trajectoire.',
  "Catégorie 3 - Titre": 'Efficacité & développement personnel au travail',
  "Catégorie 3 - Pitch": "Gagner en impact, mieux s'organiser et faire grandir son potentiel professionnel.",
  "Catégorie 4": 'Apprendre à être plus effficace et productif'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Booster sa carrière',
  "Catégorie 2 - Pitch": 'Faire évoluer sa posture professionnelle, renforcer ses capacités et devenir acteur de sa trajectoire.',
  "Catégorie 3 - Titre": 'Communication & leadership',
  "Catégorie 3 - Pitch": 'Développer sa posture, inspirer et mieux interagir dans ses relations et ses projets.',
  "Catégorie 4": 'Apprendre à mieux manager'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Booster sa carrière',
  "Catégorie 2 - Pitch": 'Faire évoluer sa posture professionnelle, renforcer ses capacités et devenir acteur de sa trajectoire.',
  "Catégorie 3 - Titre": 'Communication & leadership',
  "Catégorie 3 - Pitch": 'Développer sa posture, inspirer et mieux interagir dans ses relations et ses projets.',
  "Catégorie 4": 'Développer ses capacités de Leader'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Booster sa carrière',
  "Catégorie 2 - Pitch": 'Faire évoluer sa posture professionnelle, renforcer ses capacités et devenir acteur de sa trajectoire.',
  "Catégorie 3 - Titre": 'Efficacité & développement personnel au travail',
  "Catégorie 3 - Pitch": "Gagner en impact, mieux s'organiser et faire grandir son potentiel professionnel.",
  "Catégorie 4": 'Changer ses habitudes'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Booster sa carrière',
  "Catégorie 2 - Pitch": 'Faire évoluer sa posture professionnelle, renforcer ses capacités et devenir acteur de sa trajectoire.',
  "Catégorie 3 - Titre": 'Communication & leadership',
  "Catégorie 3 - Pitch": 'Développer sa posture, inspirer et mieux interagir dans ses relations et ses projets.',
  "Catégorie 4": 'Apprendre et améliorer sa communication'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Booster sa carrière',
  "Catégorie 2 - Pitch": 'Faire évoluer sa posture professionnelle, renforcer ses capacités et devenir acteur de sa trajectoire.',
  "Catégorie 3 - Titre": 'Efficacité & développement personnel au travail',
  "Catégorie 3 - Pitch": "Gagner en impact, mieux s'organiser et faire grandir son potentiel professionnel.",
  "Catégorie 4": 'Travailler et développer sa créativité'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Booster sa carrière',
  "Catégorie 2 - Pitch": 'Faire évoluer sa posture professionnelle, renforcer ses capacités et devenir acteur de sa trajectoire.',
  "Catégorie 3 - Titre": 'Vision & pilotage stratégique',
  "Catégorie 3 - Pitch": 'Prendre de la hauteur, structurer ses choix et mieux orienter son avenir pro.',
  "Catégorie 4": "Apprendre sur la gestion financière et l'investissement"
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Booster sa carrière',
  "Catégorie 2 - Pitch": 'Faire évoluer sa posture professionnelle, renforcer ses capacités et devenir acteur de sa trajectoire.',
  "Catégorie 3 - Titre": 'Vision & pilotage stratégique',
  "Catégorie 3 - Pitch": 'Prendre de la hauteur, structurer ses choix et mieux orienter son avenir pro.',
  "Catégorie 4": 'Vision stratégique'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Se lancer de nouveaux défis',
  "Catégorie 2 - Pitch": 'Sortir de sa zone de confort, oser le changement et explorer de nouveaux terrains de jeu personnel ou pro.',
  "Catégorie 3 - Titre": "Esprit d'entreprise & innovation",
  "Catégorie 3 - Pitch": 'Ouvrir de nouveaux possibles, transformer les idées en actions concrètes.',
  "Catégorie 4": "Se lancer dans l'entrepreunariat"
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Se lancer de nouveaux défis',
  "Catégorie 2 - Pitch": 'Sortir de sa zone de confort, oser le changement et explorer de nouveaux terrains de jeu personnel ou pro.',
  "Catégorie 3 - Titre": "Esprit d'entreprise & innovation",
  "Catégorie 3 - Pitch": 'Ouvrir de nouveaux possibles, transformer les idées en actions concrètes.',
  "Catégorie 4": 'Changer, découvrir de nouveaux horizons dans sa carrière'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Se lancer de nouveaux défis',
  "Catégorie 2 - Pitch": 'Sortir de sa zone de confort, oser le changement et explorer de nouveaux terrains de jeu personnel ou pro.',
  "Catégorie 3 - Titre": 'Ambition & dépassement de soi',
  "Catégorie 3 - Pitch": 'Sortir de sa zone de confort, viser haut et oser aller plus loin que prévu.',
  "Catégorie 4": "S'inpirer des réussites"
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Se lancer de nouveaux défis',
  "Catégorie 2 - Pitch": 'Sortir de sa zone de confort, oser le changement et explorer de nouveaux terrains de jeu personnel ou pro.',
  "Catégorie 3 - Titre": 'Ambition & dépassement de soi',
  "Catégorie 3 - Pitch": 'Sortir de sa zone de confort, viser haut et oser aller plus loin que prévu.',
  "Catégorie 4": 'Dévélopper ses capacités'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Développement personnel',
  "Catégorie 2 - Pitch": "Se transformer de l'intérieur, comprendre ses émotions et faire progresser ses comportements au quotidien.",
  "Catégorie 3 - Titre": "S'affirmer et mieux gérer ses émotions",
  "Catégorie 3 - Pitch": 'Se comprendre, poser ses limites et accueillir ses émotions avec plus de justesse.',
  "Catégorie 4": 'Développer la confiance en soi'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Développement personnel',
  "Catégorie 2 - Pitch": "Se transformer de l'intérieur, comprendre ses émotions et faire progresser ses comportements au quotidien.",
  "Catégorie 3 - Titre": "S'affirmer et mieux gérer ses émotions",
  "Catégorie 3 - Pitch": 'Se comprendre, poser ses limites et accueillir ses émotions avec plus de justesse.',
  "Catégorie 4": "Gérer le stress et de l'anxiété"
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Développement personnel',
  "Catégorie 2 - Pitch": "Se transformer de l'intérieur, comprendre ses émotions et faire progresser ses comportements au quotidien.",
  "Catégorie 3 - Titre": "S'affirmer et mieux gérer ses émotions",
  "Catégorie 3 - Pitch": 'Se comprendre, poser ses limites et accueillir ses émotions avec plus de justesse.',
  "Catégorie 4": 'Travailler sa communication aux autres'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Développement personnel',
  "Catégorie 2 - Pitch": "Se transformer de l'intérieur, comprendre ses émotions et faire progresser ses comportements au quotidien.",
  "Catégorie 3 - Titre": "Changer ses habitudes et mieux s'organiser",
  "Catégorie 3 - Pitch": 'Avancer pas à pas vers une version plus équilibrée, structurée et épanouie de soi-même.',
  "Catégorie 4": 'Se motiver par un autre mode de pensée'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Développement personnel',
  "Catégorie 2 - Pitch": "Se transformer de l'intérieur, comprendre ses émotions et faire progresser ses comportements au quotidien.",
  "Catégorie 3 - Titre": "Changer ses habitudes et mieux s'organiser",
  "Catégorie 3 - Pitch": 'Avancer pas à pas vers une version plus équilibrée, structurée et épanouie de soi-même.',
  "Catégorie 4": 'Apprendre à maîtriser le temps et sa concentration'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Développement personnel',
  "Catégorie 2 - Pitch": "Se transformer de l'intérieur, comprendre ses émotions et faire progresser ses comportements au quotidien.",
  "Catégorie 3 - Titre": "Changer ses habitudes et mieux s'organiser",
  "Catégorie 3 - Pitch": 'Avancer pas à pas vers une version plus équilibrée, structurée et épanouie de soi-même.',
  "Catégorie 4": 'Apprendre à faire des choix'
},
  {
  "Catégorie 1 - Titre": 'Développer ses compétences',
  "Catégorie 1 - Pitch": 'Faire évoluer ses talents, nourrir sa curiosité et développer son potentiel personnel et professionnel',
  "Catégorie 2 - Titre": 'Développement personnel',
  "Catégorie 2 - Pitch": "Se transformer de l'intérieur, comprendre ses émotions et faire progresser ses comportements au quotidien.",
  "Catégorie 3 - Titre": "Changer ses habitudes et mieux s'organiser",
  "Catégorie 3 - Pitch": 'Avancer pas à pas vers une version plus équilibrée, structurée et épanouie de soi-même.',
  "Catégorie 4": 'Evoluer , se transformer'
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Épanouissement personnel',
  "Catégorie 2 - Pitch": "Se reconstruire, retrouver l'estime de soi et guérir ce qui a besoin d'attention.",
  "Catégorie 3 - Titre": 'Guérir ses blessures émotionnelles',
  "Catégorie 3 - Pitch": 'Faire la paix avec ce qui pèse, panser les douleurs et reconstruire doucement son équilibre.',
  "Catégorie 4": 'Apprendre à se relever après un echec'
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Épanouissement personnel',
  "Catégorie 2 - Pitch": "Se reconstruire, retrouver l'estime de soi et guérir ce qui a besoin d'attention.",
  "Catégorie 3 - Titre": 'Guérir ses blessures émotionnelles',
  "Catégorie 3 - Pitch": 'Faire la paix avec ce qui pèse, panser les douleurs et reconstruire doucement son équilibre.',
  "Catégorie 4": 'Comprendre et apprendre à guérir émotionnellement'
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Épanouissement personnel',
  "Catégorie 2 - Pitch": "Se reconstruire, retrouver l'estime de soi et guérir ce qui a besoin d'attention.",
  "Catégorie 3 - Titre": 'Améliorer son bien-être émotionnel',
  "Catégorie 3 - Pitch": "Cultiver l'estime de soi, nourrir sa joie et retrouver une forme de stabilité intérieure.",
  "Catégorie 4": 'Estime et amour de soi'
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Épanouissement personnel',
  "Catégorie 2 - Pitch": "Se reconstruire, retrouver l'estime de soi et guérir ce qui a besoin d'attention.",
  "Catégorie 3 - Titre": 'Améliorer son bien-être émotionnel',
  "Catégorie 3 - Pitch": "Cultiver l'estime de soi, nourrir sa joie et retrouver une forme de stabilité intérieure.",
  "Catégorie 4": "S'affirmer et se libérer en temps que femme"
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Épanouissement personnel',
  "Catégorie 2 - Pitch": "Se reconstruire, retrouver l'estime de soi et guérir ce qui a besoin d'attention.",
  "Catégorie 3 - Titre": 'Améliorer son bien-être émotionnel',
  "Catégorie 3 - Pitch": "Cultiver l'estime de soi, nourrir sa joie et retrouver une forme de stabilité intérieure.",
  "Catégorie 4": 'Améliorer son moral'
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Épanouissement personnel',
  "Catégorie 2 - Pitch": "Se reconstruire, retrouver l'estime de soi et guérir ce qui a besoin d'attention.",
  "Catégorie 3 - Titre": 'Améliorer son bien-être émotionnel',
  "Catégorie 3 - Pitch": "Cultiver l'estime de soi, nourrir sa joie et retrouver une forme de stabilité intérieure.",
  "Catégorie 4": "S'affirmer et se libérer de la société"
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Acquérir des compétences de vie',
  "Catégorie 2 - Pitch": "Découvrir des outils concrets pour mieux se comprendre, mieux vivre et mieux s'entourer.",
  "Catégorie 3 - Titre": 'Mieux vivre avec soi-même',
  "Catégorie 3 - Pitch": 'Trouver des outils pour mieux se comprendre, gérer ses émotions et avancer sereinement.',
  "Catégorie 4": "Apprendre à gérer son stress et l'anxiété"
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Acquérir des compétences de vie',
  "Catégorie 2 - Pitch": "Découvrir des outils concrets pour mieux se comprendre, mieux vivre et mieux s'entourer.",
  "Catégorie 3 - Titre": 'Mieux vivre avec les autres',
  "Catégorie 3 - Pitch": 'Apprendre à créer des relations plus saines, plus équilibrées, plus conscientes',
  "Catégorie 4": 'Comprendre et améliorer sa communication avec les autres et viser des relations positives'
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Acquérir des compétences de vie',
  "Catégorie 2 - Pitch": "Découvrir des outils concrets pour mieux se comprendre, mieux vivre et mieux s'entourer.",
  "Catégorie 3 - Titre": 'Mieux vivre avec soi-même',
  "Catégorie 3 - Pitch": 'Trouver des outils pour mieux se comprendre, gérer ses émotions et avancer sereinement.',
  "Catégorie 4": 'Apprendre à se motiver et travailler la pensée positive'
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Acquérir des compétences de vie',
  "Catégorie 2 - Pitch": "Découvrir des outils concrets pour mieux se comprendre, mieux vivre et mieux s'entourer.",
  "Catégorie 3 - Titre": 'Mieux vivre avec les autres',
  "Catégorie 3 - Pitch": 'Apprendre à créer des relations plus saines, plus équilibrées, plus conscientes',
  "Catégorie 4": 'Apprendre à gérer la codépendance et les relations toxiques'
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Bien-être & spiritualité',
  "Catégorie 2 - Pitch": 'Prendre du recul, se recentrer et nourrir une paix intérieure durable.',
  "Catégorie 3 - Titre": 'Trouver du sens',
  "Catégorie 3 - Pitch": 'Redonner du sens à son parcours, réinterroger ce qui compte vraiment.',
  "Catégorie 4": "Apprendre à aller à l'essentiel"
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Bien-être & spiritualité',
  "Catégorie 2 - Pitch": 'Prendre du recul, se recentrer et nourrir une paix intérieure durable.',
  "Catégorie 3 - Titre": 'Trouver du sens',
  "Catégorie 3 - Pitch": 'Redonner du sens à son parcours, réinterroger ce qui compte vraiment.',
  "Catégorie 4": "Se lancer dans l'introspection, la quête de sens et de soi"
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Bien-être & spiritualité',
  "Catégorie 2 - Pitch": 'Prendre du recul, se recentrer et nourrir une paix intérieure durable.',
  "Catégorie 3 - Titre": 'Retrouver la paix intérieure',
  "Catégorie 3 - Pitch": 'Créer un espace de calme, de respiration, et de présence dans son quotidien.',
  "Catégorie 4": 'Chercher et trouver la pleine conscience'
},
  {
  "Catégorie 1 - Titre": 'Aller mieux',
  "Catégorie 1 - Pitch": "Retrouver de l'équilibre, panser ses blessures, prendre soin de soi en profondeur.",
  "Catégorie 2 - Titre": 'Bien-être & spiritualité',
  "Catégorie 2 - Pitch": 'Prendre du recul, se recentrer et nourrir une paix intérieure durable.',
  "Catégorie 3 - Titre": 'Retrouver la paix intérieure',
  "Catégorie 3 - Pitch": 'Créer un espace de calme, de respiration, et de présence dans son quotidien.',
  "Catégorie 4": "Retrouver de l'énergie"
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": 'Vivre des expériences humaines fortes',
  "Catégorie 2 - Pitch": 'Plonger dans des récits puissants, traverser des aventures humaines et vibrer avec celles et ceux qui ont osé.',
  "Catégorie 3 - Titre": 'Aventure & dépassement',
  "Catégorie 3 - Pitch": "Se plonger dans des récits puissants, faits de défis, de courage ou d'exploration.",
  "Catégorie 4": 'Univers du sport'
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": 'Vivre des expériences humaines fortes',
  "Catégorie 2 - Pitch": 'Plonger dans des récits puissants, traverser des aventures humaines et vibrer avec celles et ceux qui ont osé.',
  "Catégorie 3 - Titre": 'Aventure & dépassement',
  "Catégorie 3 - Pitch": "Se plonger dans des récits puissants, faits de défis, de courage ou d'exploration.",
  "Catégorie 4": 'Univers du voyage, de la nature'
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": 'Vivre des expériences humaines fortes',
  "Catégorie 2 - Pitch": 'Plonger dans des récits puissants, traverser des aventures humaines et vibrer avec celles et ceux qui ont osé.',
  "Catégorie 3 - Titre": 'Parcours de vie inspirants',
  "Catégorie 3 - Pitch": 'Découvrir ceux qui ont changé, chuté, transformé, et renaissent.',
  "Catégorie 4": 'Résilience et épreuves'
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": 'Vivre des expériences humaines fortes',
  "Catégorie 2 - Pitch": 'Plonger dans des récits puissants, traverser des aventures humaines et vibrer avec celles et ceux qui ont osé.',
  "Catégorie 3 - Titre": 'Parcours de vie inspirants',
  "Catégorie 3 - Pitch": 'Découvrir ceux qui ont changé, chuté, transformé, et renaissent.',
  "Catégorie 4": 'Réussite et transformation personnelle'
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": 'Se reconnecter à soi & trouver du sens',
  "Catégorie 2 - Pitch": 'Explorer sa vie intérieure, interroger ses choix et retrouver un cap qui résonne avec soi.',
  "Catégorie 3 - Titre": 'Introspection & quête personnelle',
  "Catégorie 3 - Pitch": "Lire pour mieux se lire soi-même. Des livres qui résonnent avec l'intérieur.",
  "Catégorie 4": 'Travailler sur la quête de soi'
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": 'Se reconnecter à soi & trouver du sens',
  "Catégorie 2 - Pitch": 'Explorer sa vie intérieure, interroger ses choix et retrouver un cap qui résonne avec soi.',
  "Catégorie 3 - Titre": 'Introspection & quête personnelle',
  "Catégorie 3 - Pitch": "Lire pour mieux se lire soi-même. Des livres qui résonnent avec l'intérieur.",
  "Catégorie 4": "Aller à l'essentiel"
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": 'Se reconnecter à soi & trouver du sens',
  "Catégorie 2 - Pitch": 'Explorer sa vie intérieure, interroger ses choix et retrouver un cap qui résonne avec soi.',
  "Catégorie 3 - Titre": 'Spiritualité & sérénité intérieure',
  "Catégorie 3 - Pitch": "Explorer l'invisible, ralentir, s'ouvrir à plus grand que soi.",
  "Catégorie 4": "S'ouvrir au monde"
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": 'Se reconnecter à soi & trouver du sens',
  "Catégorie 2 - Pitch": 'Explorer sa vie intérieure, interroger ses choix et retrouver un cap qui résonne avec soi.',
  "Catégorie 3 - Titre": 'Spiritualité & sérénité intérieure',
  "Catégorie 3 - Pitch": "Explorer l'invisible, ralentir, s'ouvrir à plus grand que soi.",
  "Catégorie 4": "Réflechir sur l'éthique, la morale et la société"
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": "Observer, comprendre & s'engager",
  "Catégorie 2 - Pitch": "Regarder le monde autrement, penser en profondeur et s'ouvrir aux grands enjeux humains.",
  "Catégorie 3 - Titre": 'Réflexion éthique & société',
  "Catégorie 3 - Pitch": 'Observer le monde avec un œil plus juste, plus critique, plus humain.',
  "Catégorie 4": 'Morale et société'
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": "Observer, comprendre & s'engager",
  "Catégorie 2 - Pitch": "Regarder le monde autrement, penser en profondeur et s'ouvrir aux grands enjeux humains.",
  "Catégorie 3 - Titre": 'Réflexion éthique & société',
  "Catégorie 3 - Pitch": 'Observer le monde avec un œil plus juste, plus critique, plus humain.',
  "Catégorie 4": 'Valeurs humaines'
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": "Observer, comprendre & s'engager",
  "Catégorie 2 - Pitch": "Regarder le monde autrement, penser en profondeur et s'ouvrir aux grands enjeux humains.",
  "Catégorie 3 - Titre": 'Engagement & témoignages sociaux',
  "Catégorie 3 - Pitch": 'Des voix qui questionnent, dénoncent, inspirent. Des récits ancrés dans le réel.',
  "Catégorie 4": 'Témoignages engagés'
},
  {
  "Catégorie 1 - Titre": "S'inspirer, découvrir, s'évader",
  "Catégorie 1 - Pitch": 'Vivez des histoires vraies, interrogez le monde, partez à la rencontre de vous-même.',
  "Catégorie 2 - Titre": "Observer, comprendre & s'engager",
  "Catégorie 2 - Pitch": "Regarder le monde autrement, penser en profondeur et s'ouvrir aux grands enjeux humains.",
  "Catégorie 3 - Titre": 'Engagement & témoignages sociaux',
  "Catégorie 3 - Pitch": 'Des voix qui questionnent, dénoncent, inspirent. Des récits ancrés dans le réel.',
  "Catégorie 4": 'Société'
}
];

export default parcoursData;